// services/api/birebirService.ts
import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse"; 
import { BirebirRequestModal } from "../../types/RequestModals/BirebirRequestModal";  
import { API_URL } from "../../constants/API_URL";
import { BirebirApprovalModal, BirebirResponseModal } from "../../types/modals";
import { BirebirError } from "../../types/ErrorModals/BirebirError";

export const getBirebir = async (request: BirebirRequestModal): Promise<BirebirResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<BirebirResponseModal[]>>(
      `${API_URL}/api/birebir/getBirebir`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Birebir ders programı bulunamadı",
          correlationId: responseData?.correlationId
        } as BirebirError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as BirebirError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as BirebirError;
    }
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as BirebirError;
  }
};

// Add new functions for approval
export const approveLesson = async (request: BirebirApprovalModal): Promise<boolean> => {
  try {
    const response = await axios.post<ApiResponse>(
      `${API_URL}/api/birebir/approveLesson`,
      request
    );
    
    return response.data.success;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      throw {
        message: responseData?.message || "Ders onaylanırken bir hata oluştu",
        correlationId: responseData?.correlationId,
        errors: responseData?.errors,
        additionalData: responseData?.additionalData
      } as BirebirError;
    }
    
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as BirebirError;
  }
};

export const withdrawApproval = async (request: BirebirApprovalModal): Promise<boolean> => {
  try {
    const response = await axios.post<ApiResponse>(
      `${API_URL}/api/birebir/withdrawApproval`,
      request
    );
    
    return response.data.success;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      throw {
        message: responseData?.message || "Ders onayı geri çekilirken bir hata oluştu",
        correlationId: responseData?.correlationId,
        errors: responseData?.errors,
        additionalData: responseData?.additionalData
      } as BirebirError;
    }
    
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as BirebirError;
  }
};